<template>
  <div class="no-data"
    :style="elStyle">
    <p>{{ $t('analytics.noData') }}</p>
  </div>
</template>

<script>
import { isInteger } from '@/libs/utils'

export default {
  name: 'AnalyticsNoData',
  props: [
    'height'
  ],
  computed: {
    elStyle () {
      let height = this.height

      if (isInteger(height)) {
        height = this.height + 'px'

        return {
          height
        }
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  position: relative;
  &> p {
    @include positionXYcenter;
    font-weight: 500;
    font-size: 13px;
    color: #767676;
  }
}
</style>
